export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Ingresa un correo valido'
  },
  required: (v: any) => !!v || 'Este campo es requerido',
}

export function downloadBase64File(base64String: string, mime: string, fileName: string) {
  const link = document.createElement('a')
  const arrayBuffer = new Uint8Array([...window.atob(base64String)].map((char) => char.charCodeAt(0)))
  link.href = window.URL.createObjectURL(new Blob([arrayBuffer]))
  link.download = fileName
  document.body.appendChild(link)
  link.click()
}
